import { Row } from '@unistocks/components/layout/flex';
import { Logo } from '@unistocks/components/logo/logo';
import {
  SIDEBAR_COLLAPSED_WIDTH,
  SIDEBAR_EXPANDED_WIDTH
} from '@unistocks/components/navigation/sidebar';
import { useSidebarPinned } from '@unistocks/shared/hooks/use-sidebar-pinned';
import { useStartPage } from '@unistocks/shared/hooks/use-start-page';
import { Link } from 'expo-router';
import { Nav, Header as TMHeader, ViewProps } from 'tamagui';

export type HeaderProps = ViewProps & {
  withSidebar?: boolean;
  renderLeft?: () => React.ReactNode;
  renderRoutes?: () => React.ReactNode;
  renderRight?: () => React.ReactNode;
};

export const Header: React.FC<HeaderProps> = ({
  withSidebar,
  renderLeft,
  renderRoutes,
  renderRight,
  ...props
}) => {
  const startPageHref = useStartPage();
  const sidebarPinned = useSidebarPinned();

  return (
    <TMHeader zIndex={'$1'} h={'$7'} $platform-web={{ pos: 'fixed', w: '100%' }} {...props}>
      <Row
        alignItems={'center'}
        gap={'$5'}
        h={'100%'}
        elevation={'$0.5'}
        shadowColor={'$shadow2'}
        backgroundColor={'$background'}
        borderBottomWidth={1}
        borderColor={'$borderColor'}
        px={'$3'}
        ml={
          withSidebar
            ? sidebarPinned
              ? SIDEBAR_EXPANDED_WIDTH
              : SIDEBAR_COLLAPSED_WIDTH
            : undefined
        }
      >
        {withSidebar ? null : (
          <Link href={startPageHref}>
            <Logo w={'$14'} />
          </Link>
        )}
        {renderLeft ? (
          <Row ml={'auto'} gap={'$3'} alignItems={'center'}>
            {renderLeft()}
          </Row>
        ) : null}
        <Nav flex={1}>{renderRoutes?.()}</Nav>
        {renderRight ? (
          <Row ml={'auto'} gap={'$3'} alignItems={'center'}>
            {renderRight()}
          </Row>
        ) : null}
      </Row>
    </TMHeader>
  );
};
